import React, { useContext, useEffect, useState } from 'react'
import styles from '../../styles/SearchFilterCheckbox.module.css'
import { SearchContext } from '../../store/search-context'
import { SearchFilterCheckboxProps } from '../../types/interface'
import { PaginationContext } from '../../store/pagination-context'


const FilterCheckbox = ({parameters, filterSlug}: SearchFilterCheckboxProps) => {

    const searchCtx = useContext(SearchContext)
    const paginationCtx = useContext(PaginationContext)
    const searchFilters = searchCtx.filters

    const onFilterParameterChange = (e: React.ChangeEvent<HTMLInputElement>, bucketSlug: string, disabled?: boolean) => {
        if(disabled) {
            return
        }
        const currentFilters = { ...searchFilters }
        const parameterName = e.target.name
        const listOfLists = ["communication_mode","cx_topics","keywords"]

        // Only listOfLists signals had to be sent as list , other signal should be sent individually 
        if(listOfLists.indexOf(bucketSlug) != -1) {
            if(currentFilters[bucketSlug]) {
                /* 
                    If filter slug exists
                    then push the parameter name(slug) to the value list
                    eg: { 'communication_mode': ['email'] }
                    on push:  { 'communication_mode': ['email', 'chat'] }
                */
                if(e.target.checked) {
                    currentFilters[bucketSlug].push(parameterName)
                } else {
                    let parameterIndex = currentFilters[bucketSlug].indexOf(parameterName)
                    currentFilters[bucketSlug].splice(parameterIndex, 1)
                    /* 
                        If all the parameters of a filter are unchecked then remove the filter from the Object
                        eg: { 'communication_mode': [] }
                        delete flags
                    */
                    if(!currentFilters[bucketSlug].length) {
                        delete currentFilters[bucketSlug]
                    }
                }
            } else {
                /* 
                    If filter slug doesn't exists
                    create new filter object key as bucketSlug and value as an array of parameter name(slug)
                    eg: { 'flags': ['excessive_hold_time'] }
                */
                currentFilters[bucketSlug] = [parameterName]
            }
        } else {
            if(e.target.checked) {
                currentFilters[parameterName] = "TRUE"
            } else {
                delete currentFilters[parameterName]
            }
        }
        searchCtx.updateFilters(currentFilters)
        paginationCtx.setDefault()
    }

    const parametersUI = parameters.length && parameters.map(({title, id, slug='', bucketSlug=filterSlug, disabled, checked}) => {
        return <label key={`${bucketSlug}-${id}`} className="d-flex pb-2 align-items-center form-check mb-0">
                    <input 
                        type="checkbox" 
                        name={slug} 
                        className={`${styles.checkboxInput} form-check-input`} 
                        checked={
                                    (
                                        (Object.keys(searchFilters).length > 0 && searchFilters[bucketSlug] && searchFilters[bucketSlug].includes(slug)) || (Object.keys(searchFilters).length > 0 && searchFilters[slug])
                                    ) || checked ? 
                                    true : false
                                } 
                        onChange={(event) => onFilterParameterChange(event, bucketSlug, disabled)}
                        disabled={disabled}
                    />
                    <span className={`form-check-label m-0 ms-2 ${styles.filterTitle}`}>
                        {title}
                    </span>
                        
                </label>
    })

    

    return (
        <>
            { parametersUI }
        </>
    )
}

export default FilterCheckbox
